import API from '@/config/api'
import axios from 'axios'

export const GET_CARDS = (params = {}) =>
  axios.get(API.school.admins.cards.all, { params })

export const GET_EXTERNAL_CARDS = (params = {}) =>
  axios.get(API.school.admins.external_cards.all, { params })

export const GET_CARDS_DELETED = (params = {}) =>
  axios.get(API.school.admins.cards.deleted, { params })

export const GET_CARDS_BLOCKED = (params = {}) =>
  axios.get(API.school.admins.cards.blocked, { params })

export const GET_ADMIN_CLASSES = () =>
  axios.get(API.school.admins.suggestions.classes)

export const GET_ADMIN_USERS = (params = {}) =>
  axios.get(API.school.admins.suggestions.users, { params })

export const GET_ADMIN_SCHOOLS = (params = {}) =>
  axios.get(API.school.admins.suggestions.schools, { params })

export const BLOCK_CARDS = payload =>
  axios.delete(API.school.admins.cards.all, {
    data: { ...payload }
  })

export const BLOCK_EXTERNAL_CARD = (id, data) =>
  axios.delete(API.school.admins.external_cards.one.replace('$id', id), { data })

export const DECLINE_EXTERNAL_CARD = id =>
  axios.delete(API.school.admins.external_cards.decline.replace('$id', id))

export const BLOCK_EXTERNAL_CARDS = payload =>
  axios.delete(API.school.admins.external_cards.all, {
    data: { ...payload }
  })

export const UNBLOCK_EXTERNAL_CARD = id =>
  axios.delete(API.school.admins.external_cards.one.replace('$id', id), {
    data: { unlock: true }
  })

export const EDIT_EXTERNAL_CARD = (cardId, data) =>
  axios.put(API.school.admins.external_cards.one.replace('$id', cardId), data)

export const DELETE_CARDS = payload =>
  axios.delete(API.school.admins.cards.blocked, {
    data: { ...payload }
  })

export const CLEAR_CARDS = payload =>
  axios.delete(API.school.admins.cards.deleted, {
    data: { ...payload }
  })

export const RESTORE_CARDS = payload =>
  axios.post(API.school.admins.cards.deleted, {
    ...payload
  })

export const ACTIVATE_CARDS = payload =>
  axios.post(API.school.admins.cards.blocked, {
    ...payload
  })

export const BLOCK_CARD = (cardId, data) =>
  axios.delete(API.school.admins.cards.one.replace('$id', cardId), { data })

export const UNLOCK_CARD = cardId =>
  axios.delete(API.school.admins.cards.one.replace('$id', cardId), {
    data: { unlock: true }
  })

export const CREATE_CARD = data =>
  axios.post(API.school.admins.cards.all, data)

export const EDIT_CARD = (cardId, data) =>
  axios.put(API.school.admins.cards.one.replace('$id', cardId), data)

export const GET_ADMIN_TEACHERS = (params = {}) =>
  axios.get(API.school.admins.teachers.all, { params })

export const GET_ADMIN_STUDENTS = (params = {}) =>
  axios.get(API.school.admins.students.all, { params })

export const GET_ADMIN_TEACHERS_PASSAGES = (params = {}) =>
  axios.get(API.school.admins.teachers.passages, { params })

export const GET_ADMIN_STUDENTS_PASSAGES = (params = {}) =>
  axios.get(API.school.admins.students.passages, { params })

export const GET_ADMIN_GUESTS_PASSAGES = (params = {}) =>
  axios.get(API.school.admins.guests.passages, { params })

export const GET_ADMIN_CARDS_ACTIONS = (params = {}) =>
  axios.get(API.school.admins.cards.events, { params })

export const GET_ADMIN_PRESENCE = (params = {}) =>
  axios.get(API.school.admins.presence, { params })

export const GET_ADMIN_SELF_NOTIFICATIONS = (params = {}) =>
  axios.get(API.school.admins.notifications.self, { params })

export const GET_ADMIN_OTHER_NOTIFICATIONS = (params = {}) =>
  axios.get(API.school.admins.notifications.other, { params })

export const ADMIN_READ_NOTIFICATION = id =>
  axios.put(API.school.admins.notifications.read.replace('$id', id))

export const GET_ADMIN_STATISTICS = (params = {}) =>
  axios.get(API.school.admins.statistics, { params })

export const GET_ADMIN_PAYER = (parentId, pupilId) =>
  axios.get(API.school.admins.payer.info.replace('$parent_id', parentId).replace('$pupil_id', pupilId))

export const GET_ADMIN_PAYER_TARIFFS = (parentId, pupilId) =>
  axios.get(API.school.admins.payer.tariffs.replace('$parent_id', parentId).replace('$pupil_id', pupilId))

export const ADMIN_RESUME_PAYER_TARIFF = (parentId, pupilId) =>
  axios.post(API.school.admins.payer.resumeCurrent.replace('$parent_id', parentId).replace('$pupil_id', pupilId))

export const ADMIN_PAUSE_PAYER_TARIFF = (parentId, pupilId) =>
  axios.post(API.school.admins.payer.pauseCurrent.replace('$parent_id', parentId).replace('$pupil_id', pupilId))

export const ADMIN_UPDATE_PAYER_TARIFF = (parentId, pupilId, data) =>
  axios.patch(API.school.admins.payer.updateCurrent.replace('$parent_id', parentId).replace('$pupil_id', pupilId), data)

export const ADMIN_SET_PAYER_TARIFF = (parentId, pupilId, tariffId) =>
  axios.post(API.school.admins.payer.setCurrent
              .replace('$parent_id', parentId)
              .replace('$pupil_id', pupilId)
              .replace('$tariff_id', tariffId))

export const ADMIN_UPDATE_STUDENT_PARENT = (parentId, pupilId, data) =>
  axios.patch(API.school.admins.students.parent.replace('$id', pupilId).replace('$parent_id', parentId), data)

export const REQUEST_REPORT_ISSUED_CARDS = params =>
  axios.post(API.school.admins.reports.issued_cards, {...params})

export const REQUEST_REPORT_BLOCKED_CARDS = params =>
  axios.post(API.school.admins.reports.blocked_cards, {...params})

export const REQUEST_REPORT_PASSAGES = params =>
  axios.post(API.school.admins.reports.passages, {...params})

export const REQUEST_REPORT_EXTENDED_CARDS = params =>
  axios.post(API.school.admins.reports.extended_cards, {...params})

export const REQUEST_REPORT_DENIED_PASSAGES = params =>
  axios.post(API.school.admins.reports.denied_passages, {...params})

export const REQUEST_REPORT_PRESENCE = params =>
  axios.post(API.school.admins.reports.presence, {...params})

export const GET_REPORT_STATUS = guid =>
  axios.get(API.school.admins.reports.status.replace('$guid', guid))

export const DOWNLOAD_REPORT = guid =>
  axios.get(API.school.admins.reports.download.replace('$guid', guid))